"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var fixtures_exports = {};
__export(fixtures_exports, {
  testAttachment: () => testAttachment,
  testAttachmentForSurvey: () => testAttachmentForSurvey,
  testProject: () => testProject,
  testProjectApprover: () => testProjectApprover,
  testProjectCoordinator: () => testProjectCoordinator,
  testProjectMember: () => testProjectMember,
  testProjectSurveyor: () => testProjectSurveyor,
  testProjectsAndTeams: () => testProjectsAndTeams,
  testSurvey: () => testSurvey,
  testTeam: () => testTeam,
  testTeamApprover: () => testTeamApprover,
  testTeamCoordinator: () => testTeamCoordinator,
  testTeamMember: () => testTeamMember,
  testTeamSurveyor: () => testTeamSurveyor,
  testUser: () => testUser,
  testUserRef: () => testUserRef,
  testWorkspace: () => testWorkspace,
  testWorkspaceActive: () => testWorkspaceActive,
  testWorkspaceAdmin: () => testWorkspaceAdmin,
  testWorkspaceDisabled: () => testWorkspaceDisabled,
  testWorkspaceOwner: () => testWorkspaceOwner
});
module.exports = __toCommonJS(fixtures_exports);
var import_lodash = require("lodash");
var import_attachment = require("../attachment/index.js");
var import_core = require("../core/index.js");
var import__ = require("../index.js");
var import_survey = require("../survey/index.js");
function testWorkspace(n) {
  return {
    id: (0, import__.randomWorkspaceId)(),
    name: `Workspace ${n}`,
    alias: (0, import_core.unsafeWorkspaceAlias)(`workspace${n}`),
    features: [],
    accessLevel: "Full"
  };
}
function testProject(n, workspaceId = (0, import__.randomWorkspaceId)()) {
  return {
    id: (0, import_core.randomProjectId)(),
    name: `Project ${n}`,
    alias: (0, import_core.unsafeProjectAlias)(`project${n}`),
    workspaceId,
    dataLicense: "Default",
    permissionModel: "Default",
    projectVisibility: "Workspace",
    mapVisibility: "Project",
    teamIds: [],
    features: [],
    qualificationRequirements: [],
    moduleIds: [],
    mapIds: []
  };
}
function testTeam(n, workspaceId = (0, import__.randomWorkspaceId)()) {
  return {
    id: (0, import_core.randomTeamId)(),
    name: `Team ${n}`,
    alias: (0, import_core.unsafeTeamAlias)(`team${n}`),
    workspaceId,
    projectIds: [],
    features: []
  };
}
function testProjectsAndTeams(linkage, workspaceId = (0, import__.randomWorkspaceId)()) {
  const pn = (0, import_lodash.sortedUniq)(linkage.map(([p, _]) => p).sort());
  const tn = (0, import_lodash.sortedUniq)(linkage.map(([_, t]) => t).sort());
  const projectIds = pn.map((_) => (0, import_core.randomProjectId)());
  const teamIds = tn.map((_) => (0, import_core.randomTeamId)());
  const projects = pn.map((n, index) => ({
    id: projectIds[index],
    name: `Project ${n}`,
    alias: (0, import_core.unsafeProjectAlias)(`project${n}`),
    workspaceId,
    dataLicense: "Default",
    permissionModel: "Default",
    projectVisibility: "Workspace",
    mapVisibility: "Project",
    teamIds: linkage.filter(([p, _]) => p === n).map(([_, t]) => teamIds[tn.indexOf(t)]),
    features: [],
    qualificationRequirements: [],
    moduleIds: [],
    mapIds: []
  }));
  const teams = tn.map((n, index) => ({
    id: teamIds[index],
    name: `Team ${n}`,
    alias: (0, import_core.unsafeTeamAlias)(`team${n}`),
    workspaceId,
    projectIds: linkage.filter(([_, t]) => t === n).map(([p, _]) => projectIds[pn.indexOf(p)]),
    features: []
  }));
  return [projects, teams];
}
function testSurvey(props) {
  const { moduleId, projectId, teamId = null, surveyor, status, schemaVersion, data } = props;
  return {
    id: (0, import__.randomSurveyId)(),
    moduleId,
    projectId,
    teamId,
    surveyor,
    status: status ?? import__.SurveyStatusEnum.Draft,
    schemaVersion: schemaVersion ?? import_survey.initialSchemaVersion,
    data,
    created: (0, import__.nowTimestamp)(),
    updated: (0, import__.nowTimestamp)()
  };
}
function testUserRef(n) {
  return (0, import__.userRef)((0, import__.unsafeScreenName)(`UserRef ${n}`), (0, import__.randomUserId)());
}
function testAttachment(n, props) {
  const { surveyId, folder, author, contentType, filename } = props;
  return {
    surveyId,
    folder: folder ?? (0, import_attachment.randomAttachmentFolder)(),
    filename: filename ?? `attachment${n}.jpg`,
    contentType: contentType ?? (0, import_attachment.unsafeContentType)("image/jpeg"),
    author: author ?? (0, import__.userRef)(),
    license: import_core.DataLicenseEnum.Default,
    created: (0, import__.nowTimestamp)(),
    updated: (0, import__.nowTimestamp)(),
    id: (0, import_attachment.randomAttachmentId)()
  };
}
function testAttachmentForSurvey(n, survey, folder) {
  const { id: surveyId, surveyor } = survey;
  return {
    surveyId,
    folder,
    filename: `attachment${n}.jpg`,
    contentType: (0, import_attachment.unsafeContentType)("image/jpeg"),
    author: surveyor,
    license: import_core.DataLicenseEnum.Default,
    created: (0, import__.nowTimestamp)(),
    updated: (0, import__.nowTimestamp)(),
    id: (0, import_attachment.randomAttachmentId)()
  };
}
function testUser(lastName, roles, qualificationRoles = []) {
  const emailName = lastName.replace(/\s+/, "-").toLowerCase();
  return {
    firstName: "Joe",
    lastName,
    email: (0, import_core.unsafeEmail)(`${emailName}@example.com`),
    screenName: (0, import__.unsafeScreenName)(`Joe ${lastName}`),
    roles,
    qualificationRoles,
    features: [],
    created: (0, import__.nowTimestamp)(),
    updated: (0, import__.nowTimestamp)(),
    id: (0, import__.randomUserId)()
  };
}
function testProjectMember(n, workspaceId, projectId) {
  return testUser(`Project Member ${n}`, [(0, import__.workspaceActiveRole)(workspaceId), (0, import__.projectMemberRole)(projectId)]);
}
function testWorkspaceDisabled(n, workspaceId) {
  return testUser(`Workspace Disabled ${n}`, [(0, import__.workspaceDisabledRole)(workspaceId)]);
}
function testWorkspaceActive(n, workspaceId) {
  return testUser(`Workspace Active ${n}`, [(0, import__.workspaceActiveRole)(workspaceId)]);
}
function testWorkspaceAdmin(n, workspaceId) {
  return testUser(`Workspace Admin ${n}`, [(0, import__.workspaceAdminRole)(workspaceId)]);
}
function testWorkspaceOwner(n, workspaceId) {
  return testUser(`Workspace Owner ${n}`, [(0, import__.workspaceOwnerRole)(workspaceId)]);
}
function testTeamMember(n, workspaceId, teamId) {
  return testUser(`Team Member ${n}`, [(0, import__.workspaceActiveRole)(workspaceId), (0, import__.teamMemberRole)(teamId)]);
}
function testProjectSurveyor(n, workspaceId, projectId) {
  return testUser(`Project Surveyor ${n}`, [(0, import__.workspaceActiveRole)(workspaceId), (0, import__.projectSurveyorRole)(projectId)]);
}
function testTeamSurveyor(n, workspaceId, teamId) {
  return testUser(`Team Surveyor ${n}`, [(0, import__.workspaceActiveRole)(workspaceId), (0, import__.teamSurveyorRole)(teamId)]);
}
function testProjectApprover(n, workspaceId, projectId) {
  return testUser(`Project Approver ${n}`, [(0, import__.workspaceActiveRole)(workspaceId), (0, import__.projectApproverRole)(projectId)]);
}
function testTeamApprover(n, workspaceId, teamId) {
  return testUser(`Team Approver ${n}`, [(0, import__.workspaceActiveRole)(workspaceId), (0, import__.teamApproverRole)(teamId)]);
}
function testProjectCoordinator(n, workspaceId, projectId) {
  return testUser(`Project Coordinator ${n}`, [(0, import__.workspaceActiveRole)(workspaceId), (0, import__.projectCoordinatorRole)(projectId)]);
}
function testTeamCoordinator(n, workspaceId, teamId) {
  return testUser(`Team Coordinator ${n}`, [(0, import__.workspaceActiveRole)(workspaceId), (0, import__.teamCoordinatorRole)(teamId)]);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  testAttachment,
  testAttachmentForSurvey,
  testProject,
  testProjectApprover,
  testProjectCoordinator,
  testProjectMember,
  testProjectSurveyor,
  testProjectsAndTeams,
  testSurvey,
  testTeam,
  testTeamApprover,
  testTeamCoordinator,
  testTeamMember,
  testTeamSurveyor,
  testUser,
  testUserRef,
  testWorkspace,
  testWorkspaceActive,
  testWorkspaceAdmin,
  testWorkspaceDisabled,
  testWorkspaceOwner
});
//# sourceMappingURL=fixtures.js.map
